module.exports = __webpack_public_path__ + "img/imagesec-2newphone1.4c3c487f.png";